import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import { ThemeProvider } from '@mui/material/styles';
import { StyleHelpIcon, theme } from './ToolTip.styles';

interface ToolTipProps {
  toolTipData: string;
}

export function ToolTip(props: ToolTipProps) {
  const { toolTipData } = props;

  return (
    <ThemeProvider theme={theme}>
      <Grid item>
        <Tooltip title={toolTipData} placement='right' arrow>
          <StyleHelpIcon />
        </Tooltip>
      </Grid>
    </ThemeProvider>
  );
}
